exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-control-label{align-items:center;background-color:var(--ds-color-london-20);box-sizing:border-box;color:var(--ds-color-london-100);display:inline-flex;font-family:var(--ds-type-system-sans);font-size:var(--ds-type-scale--1);font-weight:500;height:1.5rem;line-height:var(--ds-type-leading-lower);padding:0 .5rem}.ds-control-label--inverse{background-color:var(--ds-color-london-100);color:var(--ds-color-london-20)}", ""]);

// exports
exports.locals = {
	"ds-control-label": "ds-control-label",
	"ds-control-label--inverse": "ds-control-label--inverse"
};